import React from 'react'
import { Helmet } from 'react-helmet-async';

export default function Terms() {
  return (
    <>
      <Helmet>
        <title>서비스 이용약관 - 룰루플레이TV</title>
      </Helmet>
      <div className="container">
        <div className="row gx-2 gx-sm-2 gx-md-3">
          <div className="col-12 col-md-12 col-md-12 mx-auto">
            <h3 className="mt-5">서비스이용약관</h3>
            <div>
              <span style={{ whiteSpace: "pre-wrap" }}>
                제1조 (목 적) 서비스이용약관
                <br />이 약관은 룰루플레이TV서비스가 운영하는
                http://www.luluplaytv.com(이하 “룰루플레이TV“이라 한다)에서
                제공하는 인터넷 관련 서비스(이하 “서비스”라 한다)를 이용함에
                있어 룰루플레이TV과 이용자의 권리/의무 및 책임사항을 규정함을
                목적으로 합니다.
                <br />
                제2조 (용어정의)
                <br />① “룰루플레이TV” : 성인 콘텐츠 서비스를 목록으로 하는
                성인전용 사이트입니다.
                <br />② “이용자”란 ”룰루플레이TV“에 접속하여 이 약관에 따라
                “룰루플레이TV”이 제공하는 서비스를 받는 회원 및 비회원을
                말합니다.
                <br />③ “회원”이라 함은 “룰루플레이TV”에 개인정보를 제공하여
                회원등록을 한 자로서, “룰루플레이TV”의 정보를 지속적으로
                제공받으며, “룰루플레이TV”이 제공하는 서비스를 계속적으로
                이용할 수 있는 자를 말합니다.
                <br />④ “비회원”이라 함은 회원에 가입하지 않고
                “룰루플레이TV”이 제공하는 서비스를 이용하는 자를 말합니다.
                <br />
                제3조 (약관 등의 명시와 설명 및 개정)
                <br />① “룰루플레이TV”은 이 약관의 내용과 상호 및 대표자 성명,
                영업소 소재지 주소(소비자의 불만을 처리할 수 있는 곳의 주소를
                포함), 전화번호, 모사전송번호, 전자우편주소, 사업자등록번호,
                통신판매업신고번호, 개인정보관리책임자 등을 이용자가 쉽게 알 수
                있도록 룰루플레이TV의 초기 서비스화면(전면)에 게시합니다.
                다만, 약관의 내용은 이용자가 연결화면을 통하여 볼 수 있도록 할
                수 있습니다.
                <br />② “룰루플레이TV”은 이용자가 약관에 동의하기에 앞서
                약관에 정하여져 있는 내용 중 청약철회,배송책임, 환불조건 등과
                같은 중요한 내용을 이용자가 이해할 수 있도록 별도의 연결 화면
                또는 팝업화면 등을 제공하여 이용자의 확인을 구하여야 합니다.
                <br />③ “룰루플레이TV”은 전자상거래 등에서 소비자보호에 관한
                법률, 약관의 규제에 관한 법률, 전자거래기본법, 전자서명법,
                정보통신망 이용촉진 등에 관한 법률, 방문판매 등에 관한 법률,
                소비자보호법 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할
                수 있습니다.
                <br />④ “룰루플레이TV”이 약관을 개정할 경우에는 적용일자 및
                개정사유를 명시하여 현행약관과 함께 룰루플레이TV의 초기화면에
                그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다. 다만,
                이용자에게 불리하게 약관내용을 변경하는 경우에는 최소한 30일
                이상의 사전 유예기간을 두고 공지합니다. 이 경우
                “룰루플레이TV”은 개정 전 내용과 개정 후 내용을 명확하게
                비교하여 이용자가 알기 쉽도록 표시합니다.
                <br />⑤ “룰루플레이TV”이 약관을 개정할 경우에는 그 개정약관은
                그 적용일자 이후에 체결되는 계약에만 적용되고 그 이전에 이미
                체결된 계약에 대해서는 개정 전의 약관조항이 그대로 적용됩니다.
                다만 이미 계약을 체결한 이용자가 개정약관 조항의 적용을 받기를
                원하는 뜻을 제3항에 의한 개정약관의 공지기간 내에
                “룰루플레이TV”에 송신하여 동의를 받은 경우 에는 개정약관
                조항이 적용됩니다.
                <br />⑥ 이 약관에서 정하지 아니한 사항과 이 약관의 해석에
                관하여는 전자상거래등에서의소비자보호에관한법률,
                약관의규제등에관한법률, 공정거래위원회가 정하는 전자상거래
                등에서의소비자보호지침 및 관계법령 또는 상관례에 따릅니다.
                <br />
                제4조 (서비스의 제공 및 변경)
                <br />① “룰루플레이TV”은 다음과 같은 업무를 수행합니다.
                (콘텐츠 또는 용역에 대한 정보 제공 / 기타 “룰루플레이TV”이
                정하는 업무)
                <br />② “룰루플레이TV”은 재화 또는 용역의 품절 또는 기술적
                사양의 변경 등의 경우에는 장차 체결되는 계약에 의해 제공할 재화
                또는 용역의 내용을 변경할 수 있습니다. 이 경우에는 변경된 재화
                또는 용역의 내용 및 제공일자를 명시하여 현재의 재화 또는 용역의
                내용을 게시한 곳에 즉시 공지합니다.
                <br />③ “룰루플레이TV”이 제공하기로 이용자와 계약을 체결한
                서비스의 내용을 재화 등의 품절 또는 기술적 사양의 변경 등의
                사유로 변경할 경우에는 그 사유를 이용자에게 통지 가능한 주소로
                즉시 통지합니다.
                <br />④ 전항의 경우 “룰루플레이TV”은 이로 인하여 이용자가 입은
                손해를 배상합니다. 다만, 고의 또는 과실이 없음을 입증하는
                경우에는 그러하지 아니합니다.
                <br />
                제5조 (서비스의 중단)
                <br />① “룰루플레이TV”은 컴퓨터 등 정보통신설비의
                보수점검,교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는
                서비스의 제공을 일시적으로 중단할 수 있습니다.
                <br />② “룰루플레이TV”은 제1항의 사유로 서비스의 제공이
                일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에
                대하여 배상합니다. 단, 고의 또는 과실이 없음을 입증하는 경우에는
                그러하지 아니합니다.
                <br />③ 사업종목의 전환, 사업의 포기, 업체간의 통합 등의 이유로
                서비스를 제공할 수 없게 되는 경우에는 “룰루플레이TV”은 제8조에
                정한 방법으로 이용자에게 통지하고 당초 “룰루플레이TV”에서
                제시한 조건에 따라 소비자에게 보상합니다.
                <br />
                제6조 (회원가입)
                <br />① 이용자는 “룰루플레이TV”이 정한 가입 양식에 따라
                회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서
                회원가입을 신청합니다.
                <br />② “룰루플레이TV”은 제1항과 같이 회원으로 가입할 것을
                신청한 이용자 중 다음 각호에 해당하지 않는 한 회원으로
                등록합니다.
                <br />- 타인 명의의 신청
                <br />- 등록 내용에 허위, 기재누락, 오기가 있는 경우
                <br />- 기타 회원으로 등록하는 것이 기술상 현저히 지장이 있다고
                판단되는 경우
                <br />- 이용 신청 고객의 귀책사유로 이용승낙이 곤란한 경우
                <br />③ 회원가입계약의 성립시기는 “룰루플레이TV”의 승낙이
                회원에게 도달한 시점으로 합니다.
                <br />④ 회원은 등록사항에 변경이 있는 경우, 즉시 전자우편 기타
                방법으로 “룰루플레이TV”에 대하여 그 변경사항을 알려야 합니다.
                <br />
                제7조 (회원 탈퇴 및 자격 상실 등)
                <br />① 회원은 “룰루플레이TV”에 언제든지 탈퇴를 요청할 수
                있으며 “룰루플레이TV”은 즉시 회원탈퇴를 처리합니다.
                <br />② 회원이 다음 각호의 사유에 해당하는 경우,
                “룰루플레이TV”은 회원자격을 제한 및 정지시킬 수 있습니다.
                <br />- 가입 신청 시에 허위 내용을 등록한 경우
                <br />- “룰루플레이TV”을 이용하여 구입한 재화 등의 대금, 기타
                “룰루플레이TV”이용에 관련하여 회원이 부담하는 채무를 기일에
                지급하지 않는 경우
                <br />- 다른 사람의 “룰루플레이TV” 이용을 방해하거나 그 정보를
                도용하는 등 전자상거래 질서를 위협하는 경우
                <br />- “룰루플레이TV”을 이용하여 법령 또는 이 약관이
                금지하거나 공서양속에 반하는 행위를 하는 경우
                <br />③ “룰루플레이TV”이 회원자격을 상실시키는 경우에는
                7일간의 소명 기회를 드립니다. 본인의 의도와 상관없이 회원 정보가
                삭제되는 것을 방지하기 위한 조치 이므로 해당 기간 안에 관련
                사항에 대한 의견을 “룰루플레이TV”에 개진하고 소명의지가 없거나
                소명 기회를 무시하였을 경우에는 회원등록을 말소합니다.
                <br />
                제8조 (회원에 대한 통지)
                <br />① “룰루플레이TV”이 회원에 대한 통지를 하는 경우, 회원이
                “룰루플레이TV”과 미리 약정하여 지정한 전자우편 주소로 할 수
                있습니다.
                <br />② “룰루플레이TV”은 불특정다수 회원에 대한 통지의 경우
                1주일이상 “룰루플레이TV” 게시판에 게시함으로서 개별 통지에
                갈음할 수 있습니다. 다만, 회원 본인의 거래와 관련하여 중대한
                영향을 미치는 사항에 대하여는 개별통지를 합니다.
                <br />
                제9조 (서비스 신청)
                <br />
                “룰루플레이TV”이용자는 다음 또는 이와 유사한 방법에 의하여
                서비스를 신청하며, “룰루플레이TV”은 이용자가 서비스 신청을
                함에 있어서 다음의 각 내용을 알기 쉽게 제공하여야 합니다.
                <br />- 문서/서식의 검색 및 선택
                <br />- 성명, 주소, 전화번호, 전자우편주소(또는 이동전화번호)
                등의 입력
                <br />- 약관내용, 환불권이 제한되는 서비스 등에 대한 확인
                <br />- 재화 등의 구매신청 및 이에 관한 확인 또는
                “룰루플레이TV”의 확인에 대한 동의
                <br />- 결제방법의 선택
                <br />
                제10조 (서비스 이용의 성립)
                <br />① “룰루플레이TV”은 제9조와 같은 서비스 신청에 대하여
                다음 각호에 해당하면 승낙하지 않을 수 있습니다.
                <br />
                1. 신청 내용에 허위, 기재누락, 오기가 있는 경우
                <br />
                2. 기타 서비스 신청에 승낙하는 것이 기술상 현저히 지장이 있다고
                판단하는 경우
                <br />② “룰루플레이TV”의 수신확인통지형태로 이용자에게 도달한
                시점에 서비스 신청이 성립한 것으로 봅니다.
                <br />③ “룰루플레이TV”의 승낙의 의사표시에는 이용자의 서비스
                신청에 대한 확인 및 서비스 신청의 정정/취소 등에 관한 정보 등을
                포함하여야 합니다.
                <br />④ “동영상 플레이어” 프로그램 설치는 사용자의 자유의사에
                의하여 결정되며, “룰루플레이TV”은 프로그램을 설치하는 이용자의
                개인신상정보를 수집하거나 저장하지 않습니다.
                <br />⑤ “동영상 플레이어” 프로그램과 관련한 권리는
                “룰루플레이TV”에게 있으며 이용자에게 소유권을 준 것이 아니라
                이용허락을 준 것이므로 상업적인 용도 재배포 혹은 불법적인
                방법으로 조작하는 것을 금지합니다.
                <br />⑥ “동영상 플레이어” 프로그램을 삭제 하시고자 하시는 분은
                아래 프로그램을 다운로드 받으신 후 실행 하시면 됩니다.
                <br />
                삭제프로그램 다운로드: uninstall.exe
                <br />
                제11조 (지급방법)
                <br />
                “룰루플레이TV”에서 구매한 콘텐츠 또는 용역에 대한
                대금지급방법은 다음 각호의 방법중 가용한 방법으로 할 수
                있습니다. 단, “룰루플레이TV”은 이용자의 지급방법에 대하여
                콘텐츠 등의 대금에 어떠한 명목의 수수료도 추가하여 징수할 수
                없습니다.
                <br />- 신용카드 등의 각종 카드 결제
                <br />- 기타 전자적 지급 방법에 의한 대금 지급 등<br />
                제12조 (수신확인통지/구매신청 변경 및 취소)
                <br />① “룰루플레이TV”은 구매신청이 있는 경우 이용자에게
                수신확인통지를 합니다.
                <br />② 수신확인통지를 받은 이용자는 의사표시의 불일치 등이 있는
                경우에는 수신확인통지를 받은 후 즉시 구매신청 변경 및 취소를
                요청할 수 있고 “룰루플레이TV”은 이용자의 요청이 있는 경우에는
                지체 없이 그 요청에 따라 처리하여야 합니다. 다만 이미 대금을
                지불한 경우에는 제15조의 청약철회 등에 관한 규정에 따릅니다.
                <br />
                제13조 (서비스 공급)
                <br />① “룰루플레이TV”은 이용자와 서비스 공급시기에 관하여
                별도의 약정이 없는 결제 승인이 있는 날부터 서비스 등을 이용할 수
                있도록 필요한 조치를 취합니다.
                <br />② “룰루플레이TV”은 이용자가 구매한 콘텐츠에 대해
                이용방법, 관련 프로그램, 이용 안내 등을 명시합니다.
                <br />
                제14조 (요금 환불)
                <br />① 이용고객이 정액제 유료회원으로 가입을 한 후 다음 각 호의
                문제가 발생하여 요금환불을 요청한 경우에 회사는 이용고객이
                결제한 요금을 환불합니다.
                <br />- 회사의 서비스에 문제가 발생하여 이용고객이 서비스를 받지
                못한 경우
                <br />- 이용고객의 환불요청이 상거래의 관례에 비추어 회사에서
                정당하다고 판단되는 경우
                <br />② 전 1항의 환불조건에도 불구하고 아래 각 호의 해당이 되는
                경우 회사는 환불을 거부할 수 있습니다.
                <br />- 이용고객의 요금결제 후 기간이 3일이 경과된 경우
                <br />- 이용고객이 콘텐츠 사용을 목적으로 1개이상 상품구입을 한
                경우
                <br />- 이용고객의 컴퓨터 및 사무환경 문제로 서비스를 이용하지
                못한 경우
                <br />- 이용고객이 요금결제 후 특별한 사유 없이 환불을 요청하는
                경우
                <br />
                제15조 (서비스 철회)
                <br />① “룰루플레이TV”과 콘텐츠 사용에 관한 계약을 체결한
                이용자는 서비스 신청 승인을 받은 날부터 3일 이내에 서비스 철회
                신청을 할수 있습니다.
                <br />
                단, “14조” 범위에 벗어나지 않는 경우에 한하며 이용일수에
                해당하는 금액을 공제하고 환급하기로 합니다.
                <br />② 이용자가 제공받은 콘텐츠 및 서비스가 이용자가 원하지
                않는 정보일 경우에도 위1항과 같이 3일 이내에 서비스 철회 신청을
                할수 있습니다.
                <br />③ 어떤 이유로든 이용자의 정당한 사유에 의해 서비스 철회
                요구시 사용자가 이용한 신용카드 또는 전자화폐 결제수단으로
                콘텐츠 등의 대금을 지급한 때에는 지체 없이 당해 결제수단을
                제공한 사업자로 하여금 대금의 청구를 정시 또는 취소하도록 요청할
                수 있습니다.
                <br />
                제16조 (서비스 철회 환급 기준)
                <br />① 법정 대리인의 동의 없이 미성년자와 계약에 대한 서비스
                철회 요청시
                <br />
                “룰루플레이TV”은 어떤 이유에서든 계약을 취소에 응하며 기납부한
                요금은 전액 환급조치하며 미납요금 및 위약금 청구행위를 하지
                않습니다.
                <br />② 허위, 과장광고에 의한 이용계약
                <br />
                “룰루플레이TV”은 이용자가 제시한 사유가 서비스 사용규정에 의거
                합당하다고 판단될 경우 지체 없이 서비스 철회 요구에 응하며
                이용료 전액을 환급하기로 합니다.
                <br />③ 1개월 이상의 계속적 이용계약인 경우로서 소비자의
                귀책사유로 인한 계약해지 시 “룰루플레이TV”은 해지일까지의
                이용일수에 해당하는 금액과 총이용 금액의 10% 공제 후
                환급해주기로 합니다.
                <br />
                단, 계약체결일 또는 서비스 이용가능일로부터 10일 이내에 해지를
                요구하는 서비스일 경우에는 위약금 없이 이용일수에 해당하는
                금액만 공제하고 환급합니다.
                <br />④ 3일 이상 서비스가 중지되거나 장애가 발생한 경우 또는
                1개월 동안의 서비스 중지, 장애발생 누적시간이 72시간을 초과한
                경우 시 “룰루플레이TV”은 계약해지 및 잔여기간에 대한 이용료를
                환급해 드리기로 합니다.
                <br />
                단, 서비스 중지, 장애시간은 소비자가 회사에 통지한 후부터
                계산하되, 서비스가 불가항력(천재지변 등)이나 업체의 사전고지
                또는 과실로 인하여 중지되거나 장애가 발생한경우에는, 서비스
                중지, 장애시간 계산에서 제외됨을 원칙으로 합니다.
                <br />
                제17조 (개인정보보호)
                <br />① “룰루플레이TV”은 이용자의 정보수집 시 구매계약 이행에
                필요한 최소한의 정보를 수집합니다. 다음 사항을 필수사항으로 하며
                그 외 사항은 선택사항으로 합니다.
                <br />- 성명
                <br />- 전화번호
                <br />- 희망ID(회원의 경우)
                <br />- 비밀번호(회원의 경우)
                <br />- 전자우편주소
                <br />② “룰루플레이TV”이 이용자의 개인식별이 가능한 개인정보를
                수집하는 때에는 반드시 당해 이용자의 동의를 받습니다.
                <br />③ 제공된 개인정보는 당해 이용자의 동의 없이 목적 외의
                이용이나 제3자에게 제공할 수 없으며, 이에 대한 모든 책임은
                “룰루플레이TV”이 집니다. 다만, 다음의 경우에는 예외로 합니다.
                <br />- 배송업무상 배송업체에게 배송에 필요한 최소한의 이용자의
                정보(성명, 주소, 전화번호)를 알려주는 경우
                <br />- 통계작성, 학술연구 또는 시장조사를 위하여 필요한
                경우로서 특정 개인을 식별할 수 없는 형태로 제공하는 경우
                <br />- 콘텐츠 등의 거래에 따른 대금정산을 위하여 필요한 경우
                <br />- 도용방지를 위하여 본인확인에 필요한 경우
                <br />- 법률의 규정 또는 법률에 의하여 필요한 불가피한 사유가
                있는 경우
                <br />④ “룰루플레이TV”이 제2항과 제3항에 의해 이용자의 동의를
                받아야 하는 경우에는 개인정보관리 책임자의 신원(소속, 성명 및
                전화번호, 기타 연락처), 정보의 수집목적 및 이용목적, 제3자에
                대한 정보제공 관련사항(제공받은 자, 제공목적 및 제공할 정보의
                내용) 등 정보통신망이용촉진등에관한법률 제22조제2항이 규정한
                사항을 미리 명시하거나 고지 해야 하며 이용자는 언제든지 이
                동의를 철회할 수 있습니다.
                <br />⑤ 이용자는 언제든지 “룰루플레이TV”이 가지고 있는 자신의
                개인정보에 대해 열람 및 오류정정을 요구할 수 있으며
                “룰루플레이TV”은 이에 대해 지체 없이 필요한 조치를 취할 의무를
                집니다. 이용자가 오류의 정정을 요구한 경우에는
                “룰루플레이TV”은 그 오류를 정정할 때까지 당해 개인정보를
                이용하지 않습니다.
                <br />⑥ “룰루플레이TV”은 개인정보 보호를 위하여 관리자를
                한정하여 그 수를 최소화하며 신용카드를 포함한
                이용자의 개인정보의 분실, 도난, 유출, 변조 등으로 인한 이용자의
                손해에 대하여 모든 책임을 집니다.
                <br />⑦ “룰루플레이TV” 또는 그로부터 개인정보를 제공받은
                제3자는 개인정보의 수집목적 또는 제공받은 목적을 달성한 때에는
                당해 개인정보를 지체 없이 파기합니다.
                <br />
                제18조 (“룰루플레이TV”의 의무)
                <br />① “룰루플레이TV”은 법령과 이 약관이 금지하거나
                공서양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라
                지속적이고, 안정적으로 재화,용역을 제공하는데 최선을 다하여야
                합니다.
                <br />② “룰루플레이TV”은 이용자가 안전하게 인터넷 서비스를
                이용할 수 있도록 이용자의 개인정보(신용정보 포함)보호를 위한
                보안 시스템을 갖추어야 합니다.
                <br />③ “룰루플레이TV”이 상품이나 용역에 대하여
                「표시,광고의공정화에관한법률」 제3조 소정의 부당한
                표시,광고행위를 함으로써 이용자가 손해를 입은 때에는 이를 배상할
                책임을 집니다.
                <br />④ “룰루플레이TV”은 이용자가 원하지 않는 영리목적의
                광고성 전자우편을 발송하지 않습니다.
                <br />
                제19조 (회원의 ID 및 비밀번호에 대한 의무)
                <br />① 제17조의 경우를 제외한 ID와 비밀번호에 관한 관리책임은
                회원에게 있습니다.
                <br />② 회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는
                안 됩니다.
                <br />③ 회원이 자신의 ID 및 비밀번호를 도난 당하거나 제3자가
                사용하고 있음을 인지한 경우에는 바로 “룰루플레이TV”에 통보하고
                “룰루플레이TV”의 안내가 있는 경우에는 그에 따라야 합니다.
                <br />
                제20조 (이용자의 의무)
                <br />
                이용자는 다음 행위를 하여서는 안되며, “룰루플레이TV”은 서비스
                이용 제한 조치를 취할 수 있습니다.
                <br />① 신청 또는 변경 시 허위 내용의 등록
                <br />② 타인의 정보 도용
                <br />③ “룰루플레이TV”에 게시된 정보의 변경
                <br />④ “룰루플레이TV”이 정한 정보 이외의 정보(컴퓨터 프로그램
                등) 등의 송신 또는 게시
                <br />⑤ “룰루플레이TV”기타 제3자의 저작권 등 지적재산권에 대한
                침해
                <br />⑥ “룰루플레이TV” 기타 제3자의 명예를 손상시키거나 업무를
                방해하는 행위
                <br />⑦ 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에
                반하는 정보를 “룰루플레이TV”에 공개 또는 게시하는 행위
                <br />⑧ “룰루플레이TV”사이트 운영을 방해하는 트래픽 증가 행위
                <br />
                제21조 (저작권의 귀속 및 이용제한)
                <br />① “룰루플레이TV”이 작성한 저작물에 대한 저작권 기타
                지적재산권은 “룰루플레이TV”에 귀속합니다.
                <br />- “룰루플레이TV”의 사전 허가 없이 “룰루플레이TV”의
                서비스 저작물을 직, 간접적으로 변조, 복사, 배포, 출판, 전시,
                판매 하거나 상품제작, 인터넷, 모바일 및 데이터베이스를 비롯한
                각종 정보서비스 등에 사용하는 것을 금합니다.
                <br />② “룰루플레이TV”의 서비스에 대하여 회원이 직접 게시물을
                작성할 때는 다음과 같은 내용을 준수하여서 제3자의 지적재산권을
                침해하는 일이 없도록 하여야 합니다.
                <br />- 게시물의 내용에 인용문이 포함되어 있을 경우, 그 인용문이
                회원이나 사용자의 의견에 일부 참고된 것이 아니라 내용의
                중심이라면 출처를 밝히더라도 저작권 침해에 해당됩니다. 따라서 원
                저작권자의 명시적 동의 없이 창작물을 게시해서는 안 됩니다.
                <br />- 원 저작권자의 명시적 동의 없이 원 저작권자가 만든
                콘텐츠의 전부 혹은 일부를 게시, 전재, 복사, 재배포, 변조, 판매,
                게시하는 것은 출처를 밝히더라도 저작권 침해에 해당합니다. 따라서
                원 저작권자의 명시적 동의 없이 이런 게시물을 게시하거나
                판매해서는 안됩니다.
                <br />- 회원 또는 제휴회사에서 등록한 게시자료에 대하여
                제3자로부터 저작권 및 기타 권리의 침해 또는 명예훼손, 음란성
                등의 이유로 이의가 제기된 경우, 회사는 당해 게시물을 임시 삭제할
                수 있으며, 이의를 제기한 자와 게시물 등록자 간에 소송, 합의 등을
                통해 당해 게시물에 관한 법적 문제가 종결된 후 이를 근거로 회사에
                신청이 있는 경우에만 상기 임시 삭제된 게시물은 다시 등록될 수
                있습니다. 룰루플레이TV는 어떠한 경우도 제3자와 회원간, 또는
                제3자와 제휴회사간의 법적인 문제에 대한 책임을 지지 않습니다.
                <br />
                제22조 (서비스 면책사항)
                <br />① 천재지변, 전쟁 및 기타 이에 준하는 불가항력으로 인하여
                “룰루플레이TV” “서비스”를 제공할 수 없는 경우에는 “서비스”
                제공에 대한 책임이 면제됩니다.
                <br />② “룰루플레이TV”은 회원의 귀책사유로 인한 “서비스”
                이용의 장애 또는 손해에 대하여 책임을 지지 않습니다.
                <br />③ “룰루플레이TV”은 기간통신사업자가 전기통신역무의
                제공을 중지하거나 정상적으로 제공하지 아니하여 “서비스”를
                제공하지 못한 경우에는 그에 대한 책임을 부담하지 않습니다.
                <br />④ “룰루플레이TV”은 “서비스”용 설비의 보수, 교체,
                정기점검, 공사 등 부득이한 사유로 발생한 손해에 대한 책임이
                면제됩니다.
                <br />⑤ 회원은 “룰루플레이TV” “서비스”와 관련하여 자신이
                회사에 등록한 필수등록 항목(이동전화번호, 전자우편주소 등) 및
                비밀번호의 보안에 대하여 책임을 지며, “룰루플레이TV”은 회원의
                고의나 과실로 인하여 아이디, 비밀번호 등의 회원정보가 유출되어
                발생하는 손해에 대하여는 책임을 지지 않습니다.
                <br />⑥ “룰루플레이TV”은 회원의 컴퓨터 오류에 의해 손해가
                발생한 경우, 회원이 신상정보 및 전자우편주소를 부실하게 기재하여
                손해가 발생한 경우에는 책임을 지지 않습니다.
                <br />⑦ “룰루플레이TV”은 회원 상호간 및 회원과 제3자간에
                “서비스”를 매개로 발생한 분쟁에 대해 개입할 의무가 없으며, 이로
                인한 손해를 배상할 책임이 없습니다.
                <br />⑧ “룰루플레이TV” 사이트에 연결되거나 제휴한 업체(타
                온라인사이트)에 포함되어 있는 내용의 유효성, 적합성, 법적
                합리성, 저작권 준수 여부 등에 책임을 지지 않으며, 이로 인한
                어떠한 손해에 대하여도 책임을 지지 않습니다.
                <br />
                제23조 (분쟁해결)
                <br />① “룰루플레이TV”은 이용자가 제기하는 정당한 의견이나
                불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상 처리
                기구를 설치,운영합니다.
                <br />② “룰루플레이TV”은 이용자로부터 제출되는 불만사항 및
                의견은 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가
                곤란한 경우에는 이용자에게 그 사유와 처리일정을 즉시 통보해
                드립니다.
                <br />③ “룰루플레이TV”과 이용자간에 발생한 전자상거래 분쟁과
                관련하여 이용자의 피해구제신청이 있는 경우에는 공정거래위원회
                또는 시·도지사가 의뢰하는 분쟁조정기관의 조정에 따를 수
                있습니다.
                <br />④ “룰루플레이TV”의 콘텐츠를 상업적으로 재이용하거나
                제3자에게 납품하여 이익을 취하는 경우 법정 대리인을 통한
                저작권리를 이용자에게 청구할 수 있고, 소를 통하여 제기될 경우
                저작권법에 따라 피해액을 청구합니다.
                <br />
                제24조 (재판권 및 준거법)
                <br />① “룰루플레이TV”과 이용자간에 발생한 전자상거래 분쟁에
                관한 소송은 제소 당시의 이용자의 주소에 의하고, 주소가 없는
                경우에는 거소를 관할하는 지방법원의 전속관할로 합니다.다만, 제소
                당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의
                경우에는 민사소송법상의 관할법원에 제기합니다.
                <br />② “룰루플레이TV”과 이용자간에 제기된 전자상거래 소송에는
                한국법을 적용합니다.
                <br />
                제25조 (기타조항)
                <br />
                약관을 위반하거나 서비스 이용 시, 불편사항이 있을 경우,
                고객지원센터로 문의 바랍니다.
                <br />☏ 문의 : allwithhoyun@gmail.com
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
